import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueApollo from 'vue-apollo'
import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { WebSocketLink } from 'apollo-link-ws'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { split } from 'apollo-link'
import { getMainDefinition } from 'apollo-utilities'

import './styles/quasar.styl'
const iconSet: any = require('quasar/icon-set/fontawesome-v5.js').default


import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import {
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QBtnGroup,
  QBtnDropdown,
  QIcon,
  QTooltip,
  QSeparator,
  QBanner,
  QDialog,
  QCard,
  QCardSection,
  QCardActions,
  QAvatar,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QCheckbox,
  QMenu,
  ClosePopup,
  Notify,
  Dialog
} from 'quasar'

Vue.use(Quasar, {
  config: {
    Notify: {}
  },
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QBtnGroup,
    QBtnDropdown,
    QIcon,
    QTooltip,
    QSeparator,
    QBanner,
    QDialog,
    QCard,
    QCardSection,
    QCardActions,
    QAvatar,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QCheckbox,
    QMenu,
  },
  directives: {
    ClosePopup
  },
  plugins: {
    Notify,
    Dialog
  },
  iconSet: iconSet
 })

Vue.config.productionTip = false
// Vue.config.devtools = true
// Vue.config.performance = true

Vue.use(VueApollo)




const httpLink = createHttpLink({
  // You should use an absolute URL here
  uri: __GRAPHQL_URL__,
  credentials: 'include'
})

const wsLink = new WebSocketLink({
  uri: __GRAPHQL_WS_URL__,
  options: {
    reconnect: true,
    connectionParams: {
      
    }
    
  }
})


export const apolloState = Vue.observable({
  httpError: false,
  wsError: false,
  reconnect: () => {
    // @ts-ignore
    wsLink.subscriptionClient.close(false)
  }
})

// @ts-ignore
wsLink.subscriptionClient.onReconnected(() => {
  apolloState.wsError = false
})
// @ts-ignore
wsLink.subscriptionClient.onDisconnected((err: any) => {
  apolloState.wsError = true
})
// @ts-ignore
wsLink.subscriptionClient.onError((err: any) => {
  console.log('wsLink::onError', err)
  apolloState.wsError = true
})

// @ts-ignore
window.wsLink = wsLink.subscriptionClient

const link = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query)
    return definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
  },
  wsLink,
  httpLink
)



const cache = new InMemoryCache()


// Create the apollo client
const apolloClient = new ApolloClient({
  link,
  cache,
  connectToDevTools: true,
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
})


new Vue({
  router,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')
